import type { ReactNode } from 'react';
import { BrandLogo } from './BrandLogo';
import { IMPRESSUM_URL } from '../lib/legalLinks';

type AuthPageLayoutProps = {
  children: ReactNode;
};

/** Two-column auth shell: dark hero left (desktop), form/content right — matches /login. */
export function AuthPageLayout({ children }: AuthPageLayoutProps) {
  return (
    <div className="theme-light min-h-screen flex">
      <div className="login-hero-panel hidden lg:flex lg:w-[45%] flex-col justify-between p-10">
        <BrandLogo onDark />

        <div className="w-full mt-auto mb-16 pb-4 max-w-xl">
          <h1 className="login-hero-heading">
            Bring deinen Betrieb
            <br />
            auf das nächste Level.
          </h1>
          <p className="login-hero-subcopy">
            Von der ersten Kundenanfrage bis zur bezahlten Schlussrechnung — alles in einer Plattform.
          </p>
        </div>
      </div>

      <div className="flex-1 flex flex-col p-6 bg-white text-slate-900">
        <div className="flex-1 flex flex-col items-center justify-center">
          <div className="lg:hidden mb-8 flex justify-center">
            <BrandLogo />
          </div>
          <div className="w-full max-w-sm text-slate-900">{children}</div>
        </div>
        <footer className="pt-6 flex justify-center text-xs text-slate-400">
          <a
            href={IMPRESSUM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-slate-600 hover:underline"
          >
            Impressum
          </a>
        </footer>
      </div>
    </div>
  );
}
